import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        timeSeconds: '获取验证码',
        verifyInfo: null,
        verifyCodeInfo: null
    },
    mutations: {
          timeChange (state, data) {
              state.timeSeconds = data
          },
          setVerifyInfo (state, data) {
              state.verifyInfo = data
          },
          setVerifyCodeInfo (state, data) {
              state.verifyCodeInfo = data
          }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js